// extracted by mini-css-extract-plugin
export var audioPlayer = "_pz-0";